import { Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import TextAreaField from "@saleor/components/TextAreaField";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React from "react";
import { useIntl } from "react-intl";

interface AdditionalTabProps {
  formik: FormikProps<any>;
}

const useStyles = makeStyles(
  theme => ({
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "8px 16px",
      marginTop: 5,
      minHeight: 40
    },
    boxMinHeight: {
      minHeight: 100
    },
    routeSearch: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    routerInput: {},
    routerBtn: {
      order: 1,
      height: 38
    },
    textarea: {}
  }),
  { name: "AdditionalTab" }
);

const AdditionalTab: React.FC<AdditionalTabProps> = props => {
  const { formik } = props;
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Internal Comments to Warehouse"
            })}
          </MyTypography>
          <TextAreaField
            maxLength={1320}
            lineLimit={132}
            rowsMax={10}
            className={classes.textarea}
            name={"internalCommentsToWarehouse"}
            id="internalCommentsToWarehouse"
            onBlur={formik.handleChange}
            onChange={() => null}
            rowsMin={3}
            value={formik.values.internalCommentsToWarehouse ?? ""}
            data-testid="internal-comments-to-warehouse-input"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Internal Comments to Logistic"
            })}
          </MyTypography>
          <TextAreaField
            maxLength={1320}
            lineLimit={132}
            rowsMax={10}
            name={"internalCommentsToLogistic"}
            id="internalCommentsToLogistic"
            onBlur={formik.handleChange}
            onChange={() => null}
            rowsMin={3}
            value={formik.values.internalCommentsToLogistic ?? ""}
            data-testid="internal-comments-to-logistic-input"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "External Comments to Customer"
            })}
          </MyTypography>
          <TextAreaField
            maxLength={1320}
            lineLimit={132}
            rowsMax={10}
            name={"externalCommentsToCustomer"}
            id="externalCommentsToCustomer"
            onBlur={formik.handleChange}
            onChange={() => null}
            rowsMin={3}
            value={formik.values.externalCommentsToCustomer ?? ""}
            data-testid="external-comments-to-customer-input"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({ defaultMessage: "Production information" })}
          </MyTypography>
          <TextAreaField
            maxLength={1320}
            lineLimit={132}
            rowsMax={10}
            name={"productInformation"}
            id="productInformation"
            onBlur={formik.handleChange}
            onChange={() => null}
            rowsMin={3}
            value={formik.values.productInformation ?? ""}
            data-testid="product-information-input"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AdditionalTab;
